module.exports = {"name":"FlexSupport","parameters":[{"name":"customLabelsEnabled","value":false}]}